import ArrowLeftIcon from "assets/icons/ArrowLeftIcon";
import { Link } from "react-router-dom";
import { useAppSelector } from "store/hooks";
import { getSettings } from "store/slices";
import { twMerge } from "tailwind-merge";

export default function HeaderSection({ bgImage, children, bgImageClasses, onBack }) {
  const { dir } = useAppSelector(getSettings);
  return (
    <div dir={dir}>
      <div
        className={twMerge("bg-cover bg-no-repeat bg-center", bgImageClasses)}
        style={{
          backgroundImage: `url(${bgImage})`,
        }}
      >
        <div className="w-full relative bg-[#EEA854] max-h-80 h-72 md:h-80 bg-opacity-80">
          <div className="container pt-6 flex flex-col justify-between h-full">
            <div className="flex items-center gap-4">
              <Link to={onBack ? onBack : -1}>
                <ArrowLeftIcon
                  className={`h-5 w-5 ${dir === "rtl" ? "rotate-180" : ""}`}
                />
              </Link>
              <Link to="/">
                <p className="text-theme-blue text-3xl">nexme</p>
              </Link>
            </div>
            {children}
          </div>
        </div>
      </div>
    </div>
  );
}
